import type { ViewProps } from '../../types';

import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { useHighlightHandlers } from '../../contexts/HighlightContext/Highlight';
import { postContactMessage } from '../../app/api';
import { ContactForm } from '../../components/ContactForm';
import { BreadCrumbs } from '../../components/BreadCrumbs';
import { Typography as MuiTypography } from '@mui/material';
import Container from '@mui/material/Container';

const Typography = React.forwardRef<HTMLInputElement, any>((props, ref) =>
  useHighlightHandlers(MuiTypography, { forwardedRef: ref, ...props })
);

export const ContactA = (props: ViewProps) => {
  const { pageContext, body, title } = props;
  const theme = useTheme();
  const titleRef = React.useRef<HTMLInputElement | null>(null);
  const bodyRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <>
      <Container maxWidth="md">
        <BreadCrumbs breadcrumbs={pageContext.breadcrumbs}/>
      </Container>
      <Container maxWidth="md" sx={{ marginBottom: theme.spacing(2) }}>
        <Typography ref={titleRef} component="h1" variant="h1" mb={2}>
          {title}
        </Typography>
        <Typography ref={bodyRef} component="p" variant="body1" mb={1}>
          {body}
        </Typography>
        <ContactForm onSubmit={postContactMessage}/>
      </Container>
    </>
  )
};